import { Box } from '@mui/material'

import { TrendingDown } from '@assets/svgs/TrendingDown'
import { emotionTheme } from '@styles/theme'
import { TrendingUp } from '@assets/svgs/TrendingUp'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { BigNumbersConsumptionDataProps } from '../context/types'
import { formattedIsoToPtBrDateTime } from '@utils/dates/formattedIsoToPtBrDateTime'
import { BudgetPreviewsStatus } from '@components/shared/BudgetPreviewsStatus'

interface ParseDetailedSummaryProps {
  data: BigNumbersConsumptionDataProps | null
}

export const parseBudgetPreviewsGrid = ({ data }: ParseDetailedSummaryProps) => {
  if (!data) return []

  const budgetAmount = Math.abs(data.budgetAmount) * -1
  const budgetPercentage = Math.abs(data.budgetPercentage) * -1

  const parsedData: ColumnDefProps[][] = data.previews.map((item) => {
    const previewAmount = Math.abs(item.previewAmount) * -1
    const previewPercentage = Math.abs(item.previewPercentage) * -1

    const deviationPercentage = previewPercentage - budgetPercentage

    const isDeviationNegative = Math.abs(previewAmount) > Math.abs(budgetAmount)

    return [
      {
        id: 'previews',
        columnName: 'Prévias',
        align: 'center',
        minWidth: '7rem',
        value: item.previewNumber ? `${item.previewNumber}ª semana` : '-'
      },
      {
        id: 'consumptionTotal',
        columnName: 'Total Consumo (R$)',
        align: 'center',
        currency: true,
        value: previewAmount
      },
      {
        id: 'previewPercentage',
        columnName: 'Prévia (%)',
        align: 'center',
        value: previewPercentage ? `-${Math.abs(previewPercentage).toFixed(2)}%`.replace('.', ',') : '-'
      },
      {
        id: 'detourPercentage',
        columnName: 'Desvio (%)',
        align: 'center',
        minWidth: '7rem',
        maxWidth: '7rem',
        value: (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4px',
              color: isDeviationNegative ? emotionTheme.colors.error.color : emotionTheme.colors.success.color
            }}
          >
            {isDeviationNegative ? <TrendingUp size="small" /> : <TrendingDown size="small" />}
            {deviationPercentage !== undefined && deviationPercentage !== null
              ? `${deviationPercentage >= 0 ? '+' : ''}${deviationPercentage.toFixed(2)}%`.replace('.', ',')
              : '-'}
          </Box>
        )
      },
      {
        id: 'lastUpdate',
        columnName: 'Última atualização',
        align: 'center',
        minWidth: '10rem',
        maxWidth: '14.5rem',
        value: item.updatedAt ? formattedIsoToPtBrDateTime(item.updatedAt) : '-'
      },
      {
        id: 'status',
        columnName: 'Status da Prévia',
        align: 'center',
        minWidth: '10rem',
        maxWidth: '14.5rem',
        withoutTooltip: true,
        value: <BudgetPreviewsStatus status={item.previewStatus} />
      }
    ]
  })

  return parsedData
}
